import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _asyncToGenerator from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/web.timers.js";
import { __decorate } from "tslib";
import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component"; // import StoreLocatorDialog from "../components/menu/store-locator/StoreLocatorDialog.vue";
// import StoricoOrdiniDialog from "../components/menu/StoricoOrdiniDialog.vue";

import Earth from "vue-material-design-icons/Earth.vue";
import ColorsIcon from "../components/icons/ColorsIcon.vue";
import ComparisonIcon from "../components/icons/ComparisonIcon.vue";
import FramesIcon from "../components/icons/FramesIcon.vue";
import CustomizationIcon from "../components/icons/CustomizationIcon.vue";
import TemplesIcon from "../components/icons/TemplesIcon.vue";
import LensesIcon from "../components/icons/LensesIcon.vue";
import PrintIcon from "../components/icons/PrintIcon.vue";
import StoreLocatorIcon from "../components/icons/StoreLocatorIcon.vue"; // import VueI18n from "vue-i18n";

var StoricoOrdiniDialog = function StoricoOrdiniDialog() {
  return import("../components/menu/StoricoOrdiniDialog.vue");
};

var StoreLocatorDialog = function StoreLocatorDialog() {
  return import("../components/menu/store-locator/StoreLocatorDialog.vue");
};

var CfgLenti = function CfgLenti() {
  return import("../components/menu/lenti/CfgLentiVDialog.vue");
};

var LoginDialog = function LoginDialog() {
  return import("../components/menu/LoginDialog.vue");
};

var CarrelloDialog = function CarrelloDialog() {
  return import("../components/menu/CarrelloDialog.vue");
};

var Home = /*#__PURE__*/function (_Vue) {
  _inherits(Home, _Vue);

  var _super = _createSuper(Home);

  function Home() {
    var _this;

    _classCallCheck(this, Home);

    _this = _super.apply(this, arguments);
    _this.activeMenu = null;
    _this.print = false;
    _this.doYouWantLenses = false;
    _this.aggiungiAlCarrello = false;
    _this.noteRiga = "";
    _this.storeLocatorDialogVisible = false;
    _this.defaultFrontModel = "OV-808SC"; // defaultFrontModel: string = "MYC-001";

    _this.defaultTemplesColor = "PL0001";
    _this.defaultFrontColor = "EP0001";
    _this.defaultSunLenses = "PRO0000773";
    _this.countryCode = "";
    _this.sizeIconLang = 0;
    _this.windowsWidth = window.innerWidth;
    _this.menuNames = [{
      id: 1,
      name: "message.frontali",
      component: function component() {
        return import("../components/menu/Frontali.vue");
      },
      active: false,
      completed: false,
      icon: FramesIcon,
      icon_active: "/images/icone/FRAMES_ACTIVE.png"
    }, {
      id: 2,
      name: "message.colori",
      component: function component() {
        return import("../components/menu/Colori.vue");
      },
      active: false,
      completed: false,
      icon: ColorsIcon,
      icon_active: "/images/icone/COLORS_ACTIVE.png"
    }, {
      id: 3,
      name: "message.Aste",
      component: function component() {
        return import("../components/menu/Aste.vue");
      },
      active: false,
      completed: false,
      icon: TemplesIcon,
      icon_active: "/images/icone/TEMPLES_ACTIVE.png"
    }, {
      id: 4,
      name: "message.Lenti",
      component: function component() {
        return import("../components/menu/Lenti.vue");
      },
      active: false,
      completed: false,
      icon: LensesIcon,
      icon_active: "/images/icone/LENSES_ACTIVE.png"
    }, {
      id: 5,
      name: "message.Incisione",
      component: function component() {
        return import("../components/menu/Personalizzazioni.vue");
      },
      active: false,
      completed: false,
      icon: CustomizationIcon,
      icon_active: "/images/icone/CUSTOMIZATION_ACTIVE.png"
    }, {
      id: 6,
      name: "message.Confronta",
      component: function component() {
        return import("../components/menu/Confronta.vue");
      },
      active: false,
      completed: false,
      icon: ComparisonIcon,
      icon_active: "/images/icone/ADD_COMPARISON_OFF_ACTIVE.png"
    }, {
      id: 7,
      name: "STORE LOCATOR",
      component: function component() {
        return import("../components/menu/StoreLocator.vue");
      },
      active: false,
      completed: false,
      icon: StoreLocatorIcon,
      icon_active: "/images/icone/STORE_LOCATOR_ACTIVE.png"
    }, {
      id: 8,
      name: "message.Stampa",
      component: function component() {
        return import("../components/menu/Stampa.vue");
      },
      active: false,
      completed: false,
      icon: PrintIcon,
      icon_active: "/images/icone/PRINT_ACTIVE.png"
    }];
    _this.lang = [{
      value: "IT",
      label: "IT"
    }, {
      value: "DE",
      label: "DE"
    }, {
      value: "ES",
      label: "ES"
    }, {
      value: "PT",
      label: "PT"
    }, {
      value: "FR",
      label: "FR"
    }, {
      value: "EN",
      label: "EN"
    }, {
      value: "US",
      label: "US"
    }];
    _this.langSelected = "";
    _this.usa_country = ["US", "CA", "PR", "AR"];
    return _this;
  } // Qui sotto mettiamo i getter e setter

  /**
   * Questa funzione ritorna il componente attivo che verrà visualizzato
   * quando seleziono una sezione per la scelta e la configurazione dell'occhiale
   */


  _createClass(Home, [{
    key: "activeComponent",
    get: function get() {
      var _this2 = this;

      if (this.activeMenu != null) {
        var ac;
        ac = this.menuNames.filter(function (c) {
          return c.name == _this2.activeMenu;
        });
        return ac[0].component;
      }

      return null;
    }
  }, {
    key: "frontModel",
    get: function get() {
      var _this$$store$state$co, _this$$store$state$co2;

      return (_this$$store$state$co = this.$store.state.configurator.frontale) === null || _this$$store$state$co === void 0 ? void 0 : (_this$$store$state$co2 = _this$$store$state$co.U_THE_MODELLO) === null || _this$$store$state$co2 === void 0 ? void 0 : _this$$store$state$co2.replace(/([0-9]+)(S)/i, "$1");
    }
  }, {
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "colore",
    get: function get() {
      return this.$store.state.configurator.colore;
    }
  }, {
    key: "colori",
    get: function get() {
      return this.$store.state.configurator.frontali.colors;
    }
  }, {
    key: "coloriAste",
    get: function get() {
      return this.$store.state.configurator.aste.allColors;
    }
  }, {
    key: "setColore",
    value: function setColore(c) {
      this.$store.commit("configurator/setColore", c);
    }
  }, {
    key: "tipoLenti",
    get: function get() {
      return this.$store.state.configurator.glassType;
    }
  }, {
    key: "lenteVistaDx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaDx;
    }
  }, {
    key: "lenteVistaSx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaSx;
    }
  }, {
    key: "carrelloDialog",
    get: function get() {
      return this.$store.state.carrelloDialog;
    }
  }, {
    key: "storicoOrdiniDialog",
    get: function get() {
      return this.$store.state.storicoOrdiniDialog;
    }
  }, {
    key: "rowNumber",
    get: function get() {
      return this.$store.getters["configurator/cart/rowNumber"];
    }
  }, {
    key: "checkErrorsFrontali",
    get: function get() {
      return this.$store.getters["configurator/frontali/checkErrors"];
    }
  }, {
    key: "checkErrorsAste",
    get: function get() {
      return this.$store.getters["configurator/aste/checkErrors"];
    }
  }, {
    key: "checkErrorsLenti",
    get: function get() {
      return this.$store.getters["configurator/lenti/checkErrors"];
    }
  }, {
    key: "configurationComplete",
    get: function get() {
      return this.$store.getters["configurator/configurationComplete"];
    }
  }, {
    key: "isGuest",
    get: function get() {
      return this.$store.getters["configurator/user/isGuest"];
    }
  }, {
    key: "user",
    get: function get() {
      return this.$store.state.configurator.user.user;
    }
  }, {
    key: "configurationsLength",
    get: function get() {
      return this.$store.state.configurator.configurations.length;
    }
  }, {
    key: "isConfigurationSaved",
    get: function get() {
      return this.$store.getters["configurator/isConfigurationSaved"];
    }
  }, {
    key: "calibro",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.calibro);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "naso",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.naso);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "frontDescription",
    get: function get() {
      return this.frontModel ? this.frontModel + (this.calibro != 0 ? " " + this.calibro + "/" + this.naso : "") : "";
    }
  }, {
    key: "currentColor",
    get: function get() {
      var _this$$store$state$co3, _this$$store$state$co4, _this$$store$state$co5;

      return (_this$$store$state$co3 = this.$store.state.configurator.colore) === null || _this$$store$state$co3 === void 0 ? void 0 : (_this$$store$state$co4 = _this$$store$state$co3.U_THE_COLORE) === null || _this$$store$state$co4 === void 0 ? void 0 : (_this$$store$state$co5 = _this$$store$state$co4.replaceAll("PL", "")) === null || _this$$store$state$co5 === void 0 ? void 0 : _this$$store$state$co5.replaceAll("EP", "");
    }
  }, {
    key: "currentTemplesColor",
    get: function get() {
      var _this$$store$state$co6, _this$$store$state$co7, _this$$store$state$co8;

      return (_this$$store$state$co6 = this.$store.state.configurator.coloreAste) === null || _this$$store$state$co6 === void 0 ? void 0 : (_this$$store$state$co7 = _this$$store$state$co6.U_THE_COLORE) === null || _this$$store$state$co7 === void 0 ? void 0 : (_this$$store$state$co8 = _this$$store$state$co7.replaceAll("PL", "")) === null || _this$$store$state$co8 === void 0 ? void 0 : _this$$store$state$co8.replaceAll("EP", "");
    }
  }, {
    key: "currentSunLenses",
    get: function get() {
      var _this$$store$state$co9, _this$$store$state$co10, _this$$store$state$co11, _this$$store$state$co12, _this$$store$state$co13;

      var lens = (_this$$store$state$co9 = this.$store.state.configurator.lenteSole) === null || _this$$store$state$co9 === void 0 ? void 0 : (_this$$store$state$co10 = _this$$store$state$co9.ItemName) === null || _this$$store$state$co10 === void 0 ? void 0 : (_this$$store$state$co11 = _this$$store$state$co10.replace("LENTE", "")) === null || _this$$store$state$co11 === void 0 ? void 0 : (_this$$store$state$co12 = _this$$store$state$co11.replace("SOLE", "")) === null || _this$$store$state$co12 === void 0 ? void 0 : (_this$$store$state$co13 = _this$$store$state$co12.replace("SOLID", "")) === null || _this$$store$state$co13 === void 0 ? void 0 : _this$$store$state$co13.split(" ");
      if (lens && lens.length > 0) return lens.find(function (el) {
        return el != "";
      });
      return "";
    }
  }, {
    key: "menuLabels",
    get: function get() {
      return [this.frontDescription.includes("/") ? this.frontDescription : this.$t("message.Campo_obbligatorio").toString(), this.currentColor ? this.currentColor : this.$t("message.Campo_obbligatorio").toString(), this.currentTemplesColor ? this.currentTemplesColor : this.$t("message.Campo_obbligatorio").toString(), this.currentSunLenses ? this.currentSunLenses : "", "", "", "", ""];
    }
  }, {
    key: "incisioneCompleted",
    get: function get() {
      return this.$store.state.configurator.frontali.name || this.$store.state.configurator.aste.intDxName || this.$store.state.configurator.aste.extDxName || this.$store.state.configurator.aste.intSxName || this.$store.state.configurator.aste.extSxName;
    } // get noteRiga() {
    //   return this.$store.state.configurator.note;
    // }
    // set noteRiga(nr: string) {
    //   this.$store.commit("configurator/setRowNotes", nr);
    // }

  }, {
    key: "rowNotes",
    get: function get() {
      return this.$store.state.configurator.note;
    },
    set: function set(nr) {
      this.$store.commit("configurator/setRowNotes", nr);
    }
  }, {
    key: "removeConfiguration",
    value: function removeConfiguration(id) {
      this.$store.commit("configurator/removeConfiguration", id);
    }
  }, {
    key: "positionForPrint",
    get: function get() {
      return this.$store.state.configurator.positionForPrint;
    },
    set: function set(v) {
      this.$store.commit("configurator/setPositionForPrint", v);
    } // resetConfiguration(f: FrontModel, c: string, ca: string, sd: string) {
    //   this.$store.commit("resetConfiguration", { f, c, ca, sd });
    // }

  }, {
    key: "checkErrorsFrontaliChanged",
    value: function checkErrorsFrontaliChanged(newV) {
      var _this3 = this;

      if (newV.length > 0) {
        newV.forEach(function (e) {
          if (e.label == "model" || e.label == "size") {
            _this3.menuNames[0].completed = false;
          } else {
            _this3.menuNames[0].completed = true;
          }

          if (e.label == "color") {
            _this3.menuNames[1].completed = false;
          } else {
            _this3.menuNames[1].completed = true;
          }
        });
      } else {
        this.menuNames[0].completed = true;
        this.menuNames[1].completed = true;
      }
    }
  }, {
    key: "checkErrorsAsteChanged",
    value: function checkErrorsAsteChanged(newV) {
      var _this4 = this;

      if (newV.length > 0) {
        newV.forEach(function (e) {
          if (e.label == "color" || e.label == "finishing") {
            _this4.menuNames[2].completed = false;
          } else {
            _this4.menuNames[2].completed = true;
          }
        });
      } else {
        this.menuNames[2].completed = true;
      }
    }
  }, {
    key: "checkErrorsLentiChanged",
    value: function checkErrorsLentiChanged(newV) {
      var _this5 = this;

      if (this.tipoLenti == "V") {
        // TODO: Implementare con gli errori forniti dalle lenti da vista
        // per adesso gestito con watch
        this.menuNames[4].completed = this.lenteVistaDx != null && this.lenteVistaSx != null;
      } else {
        if (newV.length > 0) {
          newV.forEach(function (e) {
            if (e.label == "sunLenses") {
              _this5.menuNames[4].completed = false;
            } else {
              _this5.menuNames[4].completed = true;
            }
          });
        } else {
          this.menuNames[4].completed = true;
        }
      }
    }
  }, {
    key: "changedConfigurationsLength",
    value: function changedConfigurationsLength(newV) {
      if (newV > 0) {
        this.menuNames[5].completed = true;
      } else {
        this.menuNames[5].completed = false;
      }
    }
  }, {
    key: "changedLenteVistaDx",
    value: function changedLenteVistaDx(newV) {
      if (newV) {
        this.menuNames[4].completed = true;
      } else {
        this.menuNames[4].completed = false;
      }
    }
  }, {
    key: "changedLenteVistaSx",
    value: function changedLenteVistaSx(newV) {
      if (newV) {
        this.menuNames[4].completed = true;
      } else {
        this.menuNames[4].completed = false;
      }
    }
  }, {
    key: "changedIncisioneCompleted",
    value: function changedIncisioneCompleted(newV) {
      if (newV && newV != "") {
        this.menuNames[3].completed = true;
      } else {
        this.menuNames[3].completed = false;
      }
    }
  }, {
    key: "activeMenuChanged",
    value: function activeMenuChanged(newVal) {
      if (newVal == "STORE LOCATOR") {
        console.warn("Visualizzo il dialog store locator");
        this.storeLocatorDialogVisible = true;
      } else {
        this.storeLocatorDialogVisible = false;
      }
    }
  }, {
    key: "changedConfigurationComplete",
    value: function changedConfigurationComplete(newV) {
      if (newV) {
        this.menuNames[7].completed = true;
      } else {
        this.menuNames[7].completed = false;
      }
    }
  }, {
    key: "aggiungiAlCarrelloChanged",
    value: function aggiungiAlCarrelloChanged(nVal) {
      if (nVal == false) {
        this.noteRiga = "";
      }
    }
  }, {
    key: "changedWindowsWidth",
    value: function changedWindowsWidth(nVal) {
      if (nVal >= 1201) {
        this.sizeIconLang = 48;
      } else if (nVal >= 768) {
        this.sizeIconLang = 36;
      } else if (this.windowsWidth < 768) {
        this.sizeIconLang = 0;
      } // let canvas: HTMLElement = this.$refs["canvas"] as HTMLElement;
      // console.log(canvas, "FFFFFFFFFFFFFFFFFFFFFOOOOOOOOOOOOO");
      // if (nVal < 768 && canvas) {
      //   canvas.style.maxHeight = "94vh";
      //   canvas.style.height = "calc(100% - 55px)";
      // } else if (canvas) {
      //   canvas.style.maxHeight = "100vh";
      //   canvas.style.height = "100vh";
      // }

    }
  }, {
    key: "changedLangSelected",
    value: function changedLangSelected(nVal) {
      if (nVal) {
        this.$i18n.locale = nVal;
      }
    }
  }, {
    key: "changedUser",
    value: function changedUser(nVal) {
      if (nVal) {
        this.countryCode = nVal.country;
        this.langSelected = nVal.country; // this.$i18n.locale = nVal.country;
      } else if (nVal == null) {
        this.countryCode = this.cc.data;
        this.langSelected = this.cc.data;
      }
    }
  }, {
    key: "changedFrontale",
    value: function changedFrontale(nVal) {
      if (nVal.U_THE_TECNOLOGIA == "AFF") {
        this.$store.state.affogatiEnabled = true;
      } // @ts-ignore
      // eslint-disable-next-line no-undef


      gtag("event", "setForma", {
        event_category: "frontale",
        event_label: nVal.U_THE_MODELLO
      });

      if (nVal && (this.frontModel == "OV-823C" || this.frontModel == "OV-834C") && this.colore.Category == "MULTISTRATO") {
        var c = this.colori.filter(function (cl) {
          return cl.U_THE_COLORE == "EP0001";
        });
        this.setColore(c);
      }
    }
  }, {
    key: "extractNumberFromModel",
    value: function extractNumberFromModel(inputString) {
      // Define a regular expression pattern to match the number
      var pattern = /OV-A(\d+(\.\d+)?)F/; // Use the exec method to search for the pattern in the input string

      var match = pattern.exec(inputString); // Check if a match is found

      if (match) {
        // Extract the matched number and replace ',' with '.' to ensure it's a valid number
        var numberString = match[1]; // Parse the number string to a float or integer based on its format

        var number = parseFloat(numberString);
        return number;
      } else {
        // Return null if no match is found
        return NaN;
      }
    }
  }, {
    key: "changedColoriAste",
    value: function changedColoriAste(nVal) {
      var map = new Map();

      var _iterator = _createForOfIteratorHelper(nVal),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var temple = _step.value;
          var key = this.extractNumberFromModel(temple.U_THE_MODELLO);

          if (map.has(key)) {
            map.get(key).push(temple);
          } else {
            map.set(key, [temple]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.$store.state.mappedTempleColors = map;
    } // Qui sotto inseriamo le funzioni:
    // mounted etc..

  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.windowsWidth < 768) {
                  this.activeMenu = "message.frontali";
                } // let canvas = this.$refs.canvas;
                // console.log(canvas, "FFFFFFFFFFFFFFFFFFFFFOOOOOOOOOOOOO");
                // @ts-ignore


                _context.next = 3;
                return this.$rest.getCountryCode();

              case 3:
                this.cc = _context.sent;

                if (this.isGuest) {
                  this.countryCode = this.cc.data;
                } else {
                  this.countryCode = this.user.country;
                }

                if (this.windowsWidth >= 1201) {
                  this.sizeIconLang = 48;
                } else if (this.windowsWidth >= 768) {
                  this.sizeIconLang = 36;
                } else if (this.windowsWidth < 768) {
                  this.sizeIconLang = 0;
                }

                this.langSelected = this.cc.data;

                if (this.usa_country.indexOf(this.countryCode) != -1) {
                  window.location.href = "https://usa-configurator.o-six.com/";
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }() // Qui sotto le funzioni base
    // reset() {
    //   this.resetConfiguration(
    //     this.$store.state.configurator.frontale.U_THE_MODELLO,
    //     "PL0001",
    //     "PL0001",
    //     "REGULAR"
    //   );
    // }

  }, {
    key: "openCarrelloDialog",
    value: function openCarrelloDialog(c) {
      this.activeMenu = null;
      this.$store.commit("openCloseStoricoOrdiniDialog", false);
      this.$store.commit("openCloseCarrelloDialog", c);
    }
  }, {
    key: "openStoricoOrdiniDialog",
    value: function openStoricoOrdiniDialog(c) {
      this.activeMenu = null;
      this.$store.commit("openCloseCarrelloDialog", false);
      this.$store.commit("openCloseStoricoOrdiniDialog", c);
      this.$store.dispatch("configurator/user/getUserHistory");
    }
  }, {
    key: "openLoginDialog",
    value: function openLoginDialog(c) {
      this.$store.commit("openCloseLoginDialog", c);
    }
  }, {
    key: "addOrder",
    value: function addOrder() {
      if (this.tipoLenti == "V" && this.lenteVistaDx == null && this.lenteVistaSx == null && this.countryCode == "IT") {
        this.doYouWantLenses = true;
      } else {
        this.aggiungiAlCarrello = true;
      }
    }
  }, {
    key: "confirmOrder",
    value: function confirmOrder() {
      this.$store.state.lenteSx = null;
      this.$store.state.lenteDx = null;

      if (this.aggiungiAlCarrello) {
        this.aggiungiAlCarrello = false;
      }

      if (this.rowNotes == "") {
        this.setRowNotes(this.noteRiga);
        this.noteRiga = "";
      }

      this.addToCart();
    }
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$store.dispatch("configurator/cart/addToCart");

              case 2:
                if (this.$store.state.configurator.cart.addToCartSuccess) {
                  _Message({
                    message: this.$t("message.elemento_aggiunto_al_carrello").toString(),
                    type: "success"
                  });
                } else {
                  _Message({
                    message: this.$t("message.Errore").toString(),
                    type: "error"
                  });
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addToCart() {
        return _addToCart.apply(this, arguments);
      }

      return addToCart;
    }()
  }, {
    key: "goToLenses",
    value: function goToLenses() {
      var _this6 = this;

      this.activeMenu = null;
      this.doYouWantLenses = false;
      this.menuNames.forEach(function (e) {
        if (e.id == 4) {
          _this6.activeMenu = e.name;
          e.active = true;
        }
      });
    }
  }, {
    key: "activeSection",
    value: function activeSection(item) {
      var _this7 = this;

      this.activeMenu == null ? this.activeMenu = item.name.toString() : this.activeMenu == item.name ? this.activeMenu = null : this.activeMenu = item.name.toString();

      if (this.countryCode != "IT" && this.tipoLenti == "V" && item.id == 4) {
        this.activeMenu = null;
      }

      this.menuNames.forEach(function (e) {
        e.active = false;
      });

      if (this.activeMenu != null) {
        if (item.id == 8) {
          this.activeMenu = null;

          if (this.configurationComplete) {
            this.positionForPrint = true;
            setTimeout(function () {
              _this7.$store.commit("configurator/setPrint", true);
            }, 1000);
          } else {// TODO: dobbiamo fare qualcosa se la configurazione non è completa?
          }
        } else {
          this.menuNames[item.id - 1].active = true;
        }
      }
    }
  }, {
    key: "setRowNotes",
    value: function setRowNotes(n) {
      this.$store.commit("configurator/setRowNotes", n);
    }
  }, {
    key: "resetRowNotes",
    value: function resetRowNotes() {
      this.$store.commit("resetRowNotes");
    }
  }, {
    key: "resetConfiguration",
    value: function resetConfiguration() {
      this.$store.commit("resetConfiguration", {
        forma: this.defaultFrontModel,
        colore: this.defaultFrontColor,
        coloreAste: this.defaultTemplesColor
      });
      this.$store.commit("setLenteDx", null);
      this.$store.commit("setLenteSx", null);
      this.$store.commit("resetLentiVista");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
    }
  }, {
    key: "saveConfiguration",
    value: function saveConfiguration() {
      this.$store.commit("configurator/saveConfiguration");
    }
  }]);

  return Home;
}(Vue);

__decorate([Watch("checkErrorsFrontali")], Home.prototype, "checkErrorsFrontaliChanged", null);

__decorate([Watch("checkErrorsAste")], Home.prototype, "checkErrorsAsteChanged", null);

__decorate([Watch("checkErrorsLenti")], Home.prototype, "checkErrorsLentiChanged", null);

__decorate([Watch("configurationsLength")], Home.prototype, "changedConfigurationsLength", null);

__decorate([Watch("lenteVistaDx")], Home.prototype, "changedLenteVistaDx", null);

__decorate([Watch("lenteVistaSx")], Home.prototype, "changedLenteVistaSx", null);

__decorate([Watch("incisioneCompleted")], Home.prototype, "changedIncisioneCompleted", null);

__decorate([Watch("activeMenu")], Home.prototype, "activeMenuChanged", null);

__decorate([Watch("configurationComplete")], Home.prototype, "changedConfigurationComplete", null);

__decorate([Watch("aggiungiAlCarrello")], Home.prototype, "aggiungiAlCarrelloChanged", null);

__decorate([Watch("windowsWidth")], Home.prototype, "changedWindowsWidth", null);

__decorate([Watch("langSelected")], Home.prototype, "changedLangSelected", null);

__decorate([Watch("user")], Home.prototype, "changedUser", null);

__decorate([Watch("frontale")], Home.prototype, "changedFrontale", null);

__decorate([Watch("coloriAste")], Home.prototype, "changedColoriAste", null);

Home = __decorate([Component({
  components: {
    // ...Components,
    CfgLenti: CfgLenti,
    StoreLocatorDialog: StoreLocatorDialog,
    StoricoOrdiniDialog: StoricoOrdiniDialog,
    LoginDialog: LoginDialog,
    CarrelloDialog: CarrelloDialog,
    Earth: Earth,
    ColorsIcon: ColorsIcon,
    ComparisonIcon: ComparisonIcon,
    FramesIcon: FramesIcon,
    CustomizationIcon: CustomizationIcon,
    TemplesIcon: TemplesIcon,
    LensesIcon: LensesIcon,
    PrintIcon: PrintIcon,
    StoreLocatorIcon: StoreLocatorIcon
  }
})], Home);
export default Home;